// import React, { useState } from 'react';
// // import { motion } from 'framer-motion/dist/framer-motion';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import L from 'leaflet'; 
// import 'leaflet/dist/leaflet.css';
// import './contact.css';
// import customMarkerIcon from '../../main_assets/maker.png';
// import ulevusLogo from "../../main_assets/logo1.png"; 
// import axios from 'axios';

// const Contact = () => {
//   const mapCenter = [4.1558, 9.2313];
//   const mailchimpApiKey = 'YOUR_MAILCHIMP_API_KEY';
//   const mailchimpListId = 'YOUR_MAILCHIMP_LIST_ID';
//   const customIcon = new L.Icon({
//     iconUrl: customMarkerIcon,
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
//     popupAnchor: [1, -34],
//     tooltipAnchor: [16, -28],
//     shadowSize: [41, 41],
//   });

//   const [formData, setFormData] = useState({
//     category: '',
//     name: '',
//     email: '',
//     phoneNumber: '',
//     message: '',
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       // Send data to WordPress
//       const responseWordPress = await fetch('http://localhost/ulevus/wp-json/custom/v1/contact-form', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       const dataWordPress = await responseWordPress.json();
//       console.log('WordPress Response:', dataWordPress);

//       // Send data to Mailchimp
//       const responseMailchimp = await axios.post(
//         `https://<dc>.api.mailchimp.com/3.0/lists/${mailchimpListId}/members`,
//         {
//           email_address: formData.email,
//           status: 'subscribed',
//           merge_fields: {
//             FNAME: formData.name,
//             PHONE: formData.phoneNumber,
//             MESSAGE: formData.message,
//             // Add other merge fields as needed
//           },
//         },
//         {
//           headers: {
//             Authorization: `apikey ${mailchimpApiKey}`,
//           },
//         }
//       );

//       console.log('Mailchimp Response:', responseMailchimp.data);

//       // Reset the form after submission
//       setFormData({
//         category: '',
//         name: '',
//         email: '',
//         phoneNumber: '',
//         message: '',
//       });
//     } catch (error) {
//       console.error('Error submitting form:', error);
//     }
//   };


//   return (
//     // <motion.div className="contact section__padding" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//     <div className="contact section__padding" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//       <div className="map-container">
//         <MapContainer center={mapCenter} zoom={13} style={{ height: '500px', width: '100%' }}>
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//           />
//           <Marker position={mapCenter} icon={customIcon}>
//             <Popup>A marker on the map!</Popup>
//           </Marker>
//         </MapContainer>
//       </div>

//       <div className="contact-form">
//         <form onSubmit={handleSubmit}>
//           <div className='contact-info'>
//             <p>Mountain Hub <br/> Top Floor 1st Trust <br/> building <br/> Great Soppo <br/> Buea Cameroon </p>
//             <p>Email: info@ulevus.com <br/>CALL US: <br/> Cameroon: +237 679623977 <br/>  United States +18728102021</p>
//           </div>
//           <div className="label-input-pair">
//             <label htmlFor="category">Select a Category:</label>
//             <select id="category" name="category" required onChange={handleChange} value={formData.category}>
//               <option value="" disabled>Select a category</option>
//               <option value="2">1</option>
//               <option value="3">2</option>
//               <option value="3">3</option>
//               <option value="3">4</option>
//             </select>
//           </div>


//           <div className="label-input-pair">
//             <label htmlFor="name">Name:</label>
//             <input type="text" id="name" name="name" required placeholder="Enter your name" />
//           </div>

//           <div className="label-input-pair">
//             <label htmlFor="email">Email:</label>
//             <input type="email" id="email" name="email" required placeholder="Enter your email" />
//           </div>

//           <div className="label-input-pair">
//             <label htmlFor="phoneNumber">Phone Number:</label>
//             <input
//               type="tel"
//               id="phoneNumber"
//               name="phoneNumber"
//               pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" 
//               placeholder="+237-670-000000" 
//               required
//             />
//           </div>

//           <div className="label-input-pair">
//             <label htmlFor="message">State/Region/Province and Country:</label>
//             <input type="text" id="message" name="message" required placeholder="Enter your state/region/province and country" />
//           </div>

//           <div className="label-input-pair">
//             <label htmlFor="message">Message:</label>
//             <textarea id="message" name="message" required placeholder="Enter your message" onChange={handleChange} value={formData.message}></textarea>
//           </div>

//           <div class="button-container">
//             <button type="submit">Submit</button>
//           </div>
//         </form>
//       </div>
//     </div> 
//     // </motion.div>
//   );
// };

// export default Contact;










// import React, { useState, useEffect, useRef } from 'react';
// import emailjs from '@emailjs/browser';
// import './contact.css';

// const Contact = () => {
//   const words = ['people', 'products', 'companies', 'solutions'];
//   const [displayText, setDisplayText] = useState('');
//   const currentWordIndex = useRef(0);
//   const isTyping = useRef(true);
//   const charIndex = useRef(0);
//   const [showEmailForm, setShowEmailForm] = useState(false);
  
//   // Debug log for state changes
//   useEffect(() => {
//     console.log("Modal visibility changed to:", showEmailForm);
//   }, [showEmailForm]);
//   const [emailStatus, setEmailStatus] = useState('');
//   const formRef = useRef();

//   // Form data state
//   const [formData, setFormData] = useState({
//     name: '',
//     company: '',
//     message: ''
//   });

//   useEffect(() => {
//     const typewriterEffect = () => {
//       const currentWord = words[currentWordIndex.current];
      
//       if (isTyping.current) {
//         // Typing phase - letters appear one by one
//         if (charIndex.current < currentWord.length) {
//           setDisplayText(currentWord.substring(0, charIndex.current + 1));
//           charIndex.current += 1;
//           setTimeout(typewriterEffect, 500); 
//         } else {
//           // Word is fully typed - longer pause before disappearing
//           isTyping.current = false;
//           setTimeout(typewriterEffect, 5000); 
//         }
//       } else {
//         // Clear the word completely
//         setDisplayText('');
//         charIndex.current = 0;
//         isTyping.current = true;

//         // Move to next word
//         currentWordIndex.current = (currentWordIndex.current + 1) % words.length;

//         // Longer pause before starting next word
//         setTimeout(typewriterEffect, 1000); 
//       }
//     };

//     // Initial delay before starting animation
//     const timeoutId = setTimeout(typewriterEffect, 1000);
    
//     return () => clearTimeout(timeoutId);
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setEmailStatus('sending');
    
//     // Replace these with your actual EmailJS service ID, template ID, and public key
//     const serviceId = 'YOUR_EMAILJS_SERVICE_ID';
//     const templateId = 'YOUR_EMAILJS_TEMPLATE_ID';
//     const publicKey = 'YOUR_EMAILJS_PUBLIC_KEY';
    
//     emailjs.sendForm(serviceId, templateId, formRef.current, publicKey)
//       .then((result) => {
//         console.log('Email sent successfully:', result.text);
//         setEmailStatus('success');
//         // Reset form after successful submission
//         setFormData({
//           name: '',
//           company: '',
//           message: ''
//         });
//         // Close the form after 3 seconds
//         setTimeout(() => {
//           setShowEmailForm(false);
//           setEmailStatus('');
//         }, 3000);
//       })
//       .catch((error) => {
//         console.error('Email send failed:', error.text);
//         setEmailStatus('error');
//       });
//   };

//   return (
//     <div className="contact section__padding">
//       <div className="contact-form">
//         <div className='contact-info section_padding2'>
//           <div className="image-container">
//             <div className="contact__ulev-footer-icotext">
//               <p style={{ marginRight: 'auto', background: 'none', border: 'none' }}>
//                 We are always looking <br/> to connect with great <span className="changing-word">{displayText}</span>.
//               </p>
//               <h4 style={{ marginRight: 'auto', background: 'none', border: 'none' }}>
//                 Lets Build Together
//               </h4>
//             </div>
//           </div>
//           <div className="image-container">
//             <p>Bonamoussadi, <br/> Terminus Bar <br/>(+237) 612-345-678s</p>
//             <p>email: <br/> 
//               <button 
//                 style={{
//                   textDecoration:"underline", 
//                   cursor: "pointer",
//                   background: "none",
//                   border: "none",
//                   padding: 0,
//                   margin: 0,
//                   font: "inherit",
//                   color: "inherit",
//                   fontFamily: "inherit"
//                 }} 
//                 onClick={(e) => {
//                   e.preventDefault();
//                   e.stopPropagation();
//                   console.log("Button clicked!");
//                   setShowEmailForm(true);
//                   console.log("Modal state after click:", true);
//                 }}
//               >
//                 info@ulevus.com
//               </button>
//             </p>
//             <p>Whatsapp: <br/><span style={{textDecoration:"underline"}}>(+237) 612-345-678 </span></p>
//             <p>Socials: <br/><span style={{textDecoration:"underline"}}>Instagram </span> <br/><span style={{textDecoration:"underline"}}> Facebook </span><br/> <span style={{textDecoration:"underline"}}>Twitter</span> <br/> <span style={{textDecoration:"underline"}}>LinkedIn</span></p>
//           </div>
//         </div>
//       </div>

//       {/* Email Form Modal */}
//       {showEmailForm && (
//         <div className="email-modal-overlay" onClick={() => setShowEmailForm(false)}>
//           <div className="email-modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Send us a message</h3>
//               <button 
//                 className="close-button"
//                 onClick={() => setShowEmailForm(false)}
//               >
//                 &times;
//               </button>
//             </div>
            
//             {emailStatus === 'success' ? (
//               <div className="email-success">
//                 <p>Your message has been sent successfully!</p>
//               </div>
//             ) : (
//               <form ref={formRef} onSubmit={handleSubmit} className="dark-form">
//                 <div className="form-group">
//                   <label htmlFor="name">Name</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="company">Company/name</label>
//                   <input
//                     type="text"
//                     id="company"
//                     name="company"
//                     value={formData.company}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="message">What do you want to talk about??</label>
//                   <textarea
//                     id="message"
//                     name="message"
//                     value={formData.message}
//                     onChange={handleInputChange}
//                     required
//                     rows="6"
//                   ></textarea>
//                 </div>
//                 <button 
//                   type="submit" 
//                   className="submit-button"
//                   disabled={emailStatus === 'sending'}
//                 >
//                   {emailStatus === 'sending' ? 'Sending...' : 'Send Message'}
//                 </button>
//                 {emailStatus === 'error' && <p className="error-message">Failed to send message. Please try again.</p>}
//               </form>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Contact;









import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './contact.css';

const Contact = () => {
  const words = ['people', 'products', 'companies', 'solutions'];
  const [displayText, setDisplayText] = useState('');
  const currentWordIndex = useRef(0);
  const isTyping = useRef(true);
  const charIndex = useRef(0);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailStatus, setEmailStatus] = useState('');
  const formRef = useRef();

  // Form data state
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    message: '',
    time: new Date().toLocaleString() 
  });

  useEffect(() => {
    // Initialize EmailJS with your public key
    emailjs.init("ISG04P_c0uObH1Og8");
    
    const typewriterEffect = () => {
      const currentWord = words[currentWordIndex.current];
      
      if (isTyping.current) {
        if (charIndex.current < currentWord.length) {
          setDisplayText(currentWord.substring(0, charIndex.current + 1));
          charIndex.current += 1;
          setTimeout(typewriterEffect, 200); 
        } else {
          isTyping.current = false;
          setTimeout(typewriterEffect, 2000); 
        }
      } else {
        setDisplayText('');
        charIndex.current = 0;
        isTyping.current = true;
        currentWordIndex.current = (currentWordIndex.current + 1) % words.length;
        setTimeout(typewriterEffect, 500); 
      }
    };

    const timeoutId = setTimeout(typewriterEffect, 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      time: new Date().toLocaleString() 
    });
  };

  const toggleEmailForm = () => {
    setShowEmailForm(prevState => !prevState);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailStatus('sending');
    
    // Gmail-specific template parameters
    const templateParams = {
      from_name: formData.name,
      to_email: "marcel.ulevus@gmail.com", 
      reply_to: "info@ulevus.com", 
      company: formData.company,
      message: formData.message,
      time: formData.time,
      to_name: "Ulevus Team",
      subject: `New contact from ${formData.name} at ${formData.company}` 
    };
    
    // Service ID, Template ID from EmailJS
    const serviceId = 'service_yf0fnk1'; 
    const templateId = 'template_azclhrj';
    
    console.log("Sending email with params:", templateParams);
    
    // Use send for direct parameter submission
    emailjs.send(serviceId, templateId, templateParams)
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setEmailStatus('success');
        // Reset form after successful submission
        setFormData({
          name: '',
          company: '',
          message: '',
          time: new Date().toLocaleString()
        });
        // Keep success message visible for 3 seconds
        setTimeout(() => {
          setEmailStatus('');
        }, 3000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        // More detailed error handling
        if (error.text) {
          console.error('Error details:', error.text);
        }
        setEmailStatus('error');
      });
  };

  // Open email form when email is clicked
  const handleEmailClick = () => {
    setShowEmailForm(true);
  };

  return (
    <div className="contact section__padding">
      <div className="contact-form">
        <div className='contact-info section_padding2'>
          <div className="image-container">
            <div className="contact__ulev-footer-icotext">
              <p style={{ marginRight: 'auto', background: 'none', border: 'none', fontSize: "clamp(1.5rem, 2.5vw, 2.5rem)"}}>
                We are always looking <br/> to connect with great <span className="changing-word">{displayText}</span>.
              </p>
              <button 
                style={{ 
                  marginRight: 'auto', 
                  background: 'none', 
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                  color: '#888',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  paddingTop: '2rem',
                  fontSize: '1.5rem'
                }}
                onClick={toggleEmailForm}
              >
                Let's Build Together
              </button>
            </div>
          </div>
          <div className="image-container">
            <p>Bonamoussadi, <br/> Terminus <br/> Douala, <br/> Cameroon.</p>
            <p>email: <br/> 
              <span 
                style={{
                  textDecoration:"underline", 
                  cursor: "pointer",
                }}
                onClick={handleEmailClick}
              >
                info@ulevus.com
              </span>
            </p>
            <p>Socials: <br/>
              <button 
                onClick={() => window.open('https://www.instagram.com/thisisulevus/', '_blank', 'noopener,noreferrer')}
                style={{textDecoration:"underline", cursor:"pointer", background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit'}}
              >
                Instagram
              </button> <br/>
              <button 
                onClick={() => window.open('https://web.facebook.com/thisisulevus/', '_blank', 'noopener,noreferrer')}
                style={{textDecoration:"underline", cursor:"pointer", background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit'}}
              >
                Facebook
              </button> <br/> 
              <button 
                onClick={() => window.open('https://x.com/thisisulevus/', '_blank', 'noopener,noreferrer')}
                style={{textDecoration:"underline", cursor:"pointer", background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit'}}
              >
                Twitter
              </button> <br/>
              <button 
                onClick={() => window.open('https://www.linkedin.com/company/ulevus/', '_blank', 'noopener,noreferrer')}
                style={{textDecoration:"underline", cursor:"pointer", background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit'}}
              >
                LinkedIn
              </button> <br/>
              <button 
                onClick={() => window.open('https://www.youtube.com/@thisisulevus/', '_blank', 'noopener,noreferrer')}
                style={{textDecoration:"underline", cursor:"pointer", background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit'}}
              >
                YouTube
              </button>
            </p>
          </div>
        </div>
      </div>

      {showEmailForm && (
        <div className="email-modal-overlay" onClick={toggleEmailForm}>
          <div className="email-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send us a message</h3>
              <button 
                className="close-button"
                onClick={toggleEmailForm}
                type="button"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            
            {emailStatus === 'success' ? (
              <div className="email-success">
                <p>Your message has been sent successfully!</p>
                <button 
                  className="close-button-success" 
                  onClick={toggleEmailForm}
                  type="button"
                >
                  Close
                </button>
              </div>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} className="dark-form">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your company"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Tell us about your project</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    className="styled-textarea"
                    placeholder="Describe your project or inquiry"
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="submit-button minimal-submit"
                  disabled={emailStatus === 'sending'}
                >
                  {emailStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>
                {emailStatus === 'error' && (
                  <p className="error-message">
                    Failed to send message. Please try again or contact us directly at info@ulevus.com
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;